/*
 * Puprazy Theme v3.0.0
 * Minimal vanilla JavaScript — no external dependencies
 */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ============================================================
   * 1. Mobile Menu Toggle
   * ============================================================ */

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuOverlay = document.querySelector('.mobile-menu-overlay');
  var menuClose = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('active');
    if (menuOverlay) menuOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    if (menuOverlay) menuOverlay.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (mobileMenu && mobileMenu.classList.contains('active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMenu);
  }

  if (menuClose) {
    menuClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeMenu();
    });
  }

  // Close menu on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMenu();
    }
  });


  /* ============================================================
   * 2. Sort Select
   * ============================================================ */

  document.addEventListener('change', function (e) {
    var sortSelect = e.target.closest('[data-sort-select]');
    if (!sortSelect) return;

    var value = sortSelect.value;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    window.location.href = url.toString();
  });


  /* ============================================================
   * 3. Quantity Buttons
   * ============================================================ */

  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');

    if (!minusBtn && !plusBtn) return;

    var wrapper = (minusBtn || plusBtn).closest('[data-quantity-wrapper]');
    if (!wrapper) {
      // Fall back to finding the input as a sibling
      wrapper = (minusBtn || plusBtn).parentElement;
    }

    var input = wrapper.querySelector('input[type="number"], input[name="quantity"], input[name*="updates"]');
    if (!input) return;

    var currentVal = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var max = parseInt(input.getAttribute('max'), 10) || 9999;

    if (minusBtn) {
      var newVal = currentVal - 1;
      if (newVal >= min) {
        input.value = newVal;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (plusBtn) {
      var newVal2 = currentVal + 1;
      if (newVal2 <= max) {
        input.value = newVal2;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });


  /* ============================================================
   * 4. Product Gallery — Thumbnail Click
   * ============================================================ */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;

    e.preventDefault();

    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) {
      gallery = document;
    }

    var mainImage = gallery.querySelector('[data-gallery-main]');
    if (!mainImage) return;

    var newSrc = thumb.getAttribute('data-gallery-thumb');
    var newSrcset = thumb.getAttribute('data-srcset') || '';
    var newAlt = thumb.getAttribute('data-alt') || '';

    if (newSrc) {
      mainImage.setAttribute('src', newSrc);
      if (newSrcset) {
        mainImage.setAttribute('srcset', newSrcset);
      }
      if (newAlt) {
        mainImage.setAttribute('alt', newAlt);
      }
    }

    // Update active state on thumbnails
    var allThumbs = (gallery !== document)
      ? gallery.querySelectorAll('[data-gallery-thumb]')
      : document.querySelectorAll('[data-gallery-thumb]');

    allThumbs.forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  });


  /* ============================================================
   * 5. Variant Selector
   * ============================================================ */

  document.addEventListener('click', function (e) {
    var optionBtn = e.target.closest('[data-variant-option]');
    if (!optionBtn) return;

    e.preventDefault();

    var optionGroup = optionBtn.closest('[data-option-group]');
    if (!optionGroup) return;

    // Update active state within the option group
    optionGroup.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-checked', 'false');
    });
    optionBtn.classList.add('active');
    optionBtn.setAttribute('aria-checked', 'true');

    // Gather all selected options
    var form = optionBtn.closest('form[data-product-form]');
    if (!form) return;

    var selectedOptions = [];
    form.querySelectorAll('[data-option-group]').forEach(function (group) {
      var activeOption = group.querySelector('[data-variant-option].active');
      if (activeOption) {
        selectedOptions.push(activeOption.getAttribute('data-variant-option'));
      }
    });

    // Find matching variant from JSON data
    var variantsData = form.getAttribute('data-variants');
    if (!variantsData) return;

    var variants;
    try {
      variants = JSON.parse(variantsData);
    } catch (err) {
      return;
    }

    var matchedVariant = null;
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var options = variant.options || [];
      var isMatch = true;

      for (var j = 0; j < selectedOptions.length; j++) {
        if (options[j] !== selectedOptions[j]) {
          isMatch = false;
          break;
        }
      }

      if (isMatch) {
        matchedVariant = variant;
        break;
      }
    }

    if (!matchedVariant) return;

    // Update hidden variant select
    var variantSelect = form.querySelector('select[name="id"], input[name="id"]');
    if (variantSelect) {
      variantSelect.value = matchedVariant.id;
    }

    // Update price display
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && matchedVariant.price != null) {
      var formattedPrice = formatMoney(matchedVariant.price);
      priceEl.textContent = formattedPrice;
    }

    // Update compare-at price
    var comparePriceEl = document.querySelector('[data-compare-price]');
    if (comparePriceEl) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    // Update add-to-cart button state
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');

    if (addToCartBtn) {
      if (matchedVariant.available) {
        addToCartBtn.disabled = false;
        if (addToCartText) {
          addToCartText.textContent = addToCartBtn.getAttribute('data-label-add') || 'Add to Cart';
        }
      } else {
        addToCartBtn.disabled = true;
        if (addToCartText) {
          addToCartText.textContent = addToCartBtn.getAttribute('data-label-sold-out') || 'Sold Out';
        }
      }
    }

    // Update URL with variant ID
    var url = new URL(window.location.href);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState(null, '', url.toString());

    // Update gallery image if variant has a featured image
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      var mainImage = document.querySelector('[data-gallery-main]');
      if (mainImage) {
        mainImage.setAttribute('src', matchedVariant.featured_image.src);
        if (matchedVariant.featured_image.alt) {
          mainImage.setAttribute('alt', matchedVariant.featured_image.alt);
        }
      }
    }
  });

  /**
   * Format money — Shopify prices are in cents (subunits).
   * This formats to the store's currency pattern (AED X.XX).
   */
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = (parseInt(cents, 10) / 100).toFixed(2);

    // Use the global Shopify currency format if available
    var moneyFormat = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : 'AED {{amount}}';

    return moneyFormat
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', parseInt(value, 10))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', parseInt(value, 10));
  }


  /* ============================================================
   * 6. Cart Quantity Update (Debounced Auto-Submit)
   * ============================================================ */

  var cartForm = document.querySelector('form[data-cart-form]');
  var cartUpdateTimer = null;

  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      var input = e.target.closest('input[name*="updates"]');
      if (!input) return;

      clearTimeout(cartUpdateTimer);
      cartUpdateTimer = setTimeout(function () {
        cartForm.submit();
      }, 500);
    });
  }


  /* ============================================================
   * 7. Header Scroll Effect
   * ============================================================ */

  var siteHeader = document.querySelector('.site-header');
  var scrollThreshold = 50;
  var lastKnownScroll = 0;
  var ticking = false;

  function updateHeaderScroll() {
    if (!siteHeader) return;

    if (lastKnownScroll > scrollThreshold) {
      siteHeader.classList.add('scrolled');
    } else {
      siteHeader.classList.remove('scrolled');
    }
    ticking = false;
  }

  if (siteHeader) {
    window.addEventListener('scroll', function () {
      lastKnownScroll = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderScroll);
        ticking = true;
      }
    }, { passive: true });

    // Run once on load in case page is already scrolled
    lastKnownScroll = window.scrollY;
    updateHeaderScroll();
  }


  /* ============================================================
   * 8. Accessible Focus Management
   * ============================================================ */

  // Detect keyboard navigation vs mouse — add class for focus styles
  var usingKeyboard = false;

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      usingKeyboard = true;
      document.body.classList.add('using-keyboard');
    }
  });

  document.addEventListener('mousedown', function () {
    usingKeyboard = false;
    document.body.classList.remove('using-keyboard');
  });


  /* ============================================================
   * 9. Smooth Scroll for Anchor Links
   * ============================================================ */

  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    var targetId = anchor.getAttribute('href');
    if (targetId === '#' || targetId === '') return;

    var targetEl = document.querySelector(targetId);
    if (!targetEl) return;

    e.preventDefault();

    var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
    var targetPosition = targetEl.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });

    // Update URL hash without jumping
    window.history.pushState(null, '', targetId);
  });


  /* ============================================================
   * 10. Lazy Load Images (Native + Fallback)
   * ============================================================ */

  // For browsers without native lazy loading support
  if (!('loading' in HTMLImageElement.prototype)) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');

    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
            imageObserver.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px'
      });

      lazyImages.forEach(function (img) {
        imageObserver.observe(img);
      });
    }
  }


  /* ============================================================
   * 11. Skip to Content
   * ============================================================ */

  var skipLink = document.querySelector('[data-skip-to-content]');
  if (skipLink) {
    skipLink.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = skipLink.getAttribute('href');
      var target = document.querySelector(targetId);
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus();
        target.removeAttribute('tabindex');
      }
    });
  }


  /* ============================================================
   * 12. Product Form — Add to Cart (AJAX)
   * ============================================================ */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;

    // Only AJAX submit if the form has the data attribute for it
    if (!form.hasAttribute('data-ajax-cart')) return;

    e.preventDefault();

    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');

    if (addBtn) {
      addBtn.disabled = true;
      if (addBtnText) {
        addBtnText.textContent = 'Adding...';
      }
    }

    var formData = new FormData(form);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      return response.json();
    })
    .then(function () {
      // Update cart count in header
      return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var cartCountEls = document.querySelectorAll('[data-cart-count]');
      cartCountEls.forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.style.display = '';
        }
      });

      if (addBtn) {
        addBtn.disabled = false;
        if (addBtnText) {
          addBtnText.textContent = 'Added!';
          setTimeout(function () {
            addBtnText.textContent = addBtn.getAttribute('data-label-add') || 'Add to Cart';
          }, 2000);
        }
      }
    })
    .catch(function () {
      if (addBtn) {
        addBtn.disabled = false;
        if (addBtnText) {
          addBtnText.textContent = addBtn.getAttribute('data-label-add') || 'Add to Cart';
        }
      }
    });
  });

});
